export const parseDate = (dateStr, format) => {
  if (!format) return new Date(dateStr)
  const formatParts = format.match(/(YYYY|MM|DD|HH|mm|ss|SS)/g)
  const dateParts = dateStr.match(/\d+/g)
  if (!formatParts || !dateParts || formatParts.length !== dateParts.length)
    return new Date(dateStr)

  let dateObj = {
    year: 1970,
    month: 0,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
  }
  formatParts.forEach((part, i) => {
    const value = parseInt(dateParts[i])
    switch (part) {
      case 'YYYY':
        dateObj.year = value
        break
      case 'MM':
        dateObj.month = value - 1
        break
      case 'DD':
        dateObj.day = value
        break
      case 'HH':
        dateObj.hour = value
        break
      case 'mm':
        dateObj.minute = value
        break
      case 'ss':
        dateObj.second = value
        break
      case 'SS':
        dateObj.millisecond = value
        break
    }
  })

  const date = new Date(
    dateObj.year,
    dateObj.month,
    dateObj.day,
    dateObj.hour,
    dateObj.minute,
    dateObj.second,
    dateObj.millisecond || 0
  )

  if (
    date.getFullYear() !== dateObj.year ||
    date.getMonth() !== dateObj.month ||
    date.getDate() !== dateObj.day
  ) {
    return new Date('')
  }

  return date
}
